import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs, { Dayjs } from 'dayjs';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalBody, { ModalProps } from './ModalBody';

interface CalendarModalProps extends ModalProps {
    currentDate: Date;
    setCurrentDate: (newDate: string) => void;
    mode?: 'day' | 'month';
}

const CalendarModal: React.FC<CalendarModalProps> = ({ currentDate, setCurrentDate, open, handleClose, mode = 'day' }) => {
    const [selectedDate, setSelectedDate] = useState(currentDate);
    const { t } = useTranslation();

    const handleMonthDateChange = (value: Dayjs) => {
        if (value) {
            setSelectedDate(value.toDate());
        }
    };

    return (
        <ModalBody
            title={t('calendar')}
            open={open}
            handleClose={handleClose}
            onSubmit={() => {
                setCurrentDate(selectedDate.toISOString());
            }}
            width={'fit-content'}
        >
            <div className="fx-c">
                {mode === 'day' ? (
                    <DateCalendar
                        onChange={(value) => (value ? setSelectedDate(new Date(value?.toISOString())) : null)}
                        value={dayjs(selectedDate)}
                        displayWeekNumber
                    />
                ) : (
                    <DateCalendar
                        onChange={(value) => (value ? setSelectedDate(new Date(value?.toISOString())) : null)}
                        value={dayjs(selectedDate)}
                        displayWeekNumber
                        views={['month', 'year']}
                    />
                )}
            </div>
        </ModalBody>
    );
};

export default CalendarModal;
